<template lang="">
    <div>
        <div style="display:flex; flex-direction:row;justify-content: center;">
            <div v-if="input||select" v-bind:title=tooltip > {{label}}</div>

            <template v-if="label === 'Kp1'" >
                <a v-bind:title=tooltip class="kpLink" style="display:block;margin-left:10px;" href="#" @click.prevent="openPopupKp1()">?</a>
            </template>

            <template v-if="label === 'Kp2'" >
                <a v-bind:title=tooltip class="kpLink" style="display:block;margin-left:10px;" href="#" @click.prevent="openPopupKp2()">?</a>
            </template>
        </div>
        

        <input
            v-bind:title=tooltip
            v-if="input" 
            class="input" 
            type="text" 
            @input="$emit('updateProjectParams', label, $event.target.value);
            validateInput(label, $event.target.value)" v-bind:placeholder=val 
        />

        <select 
            class="input" 
            v-model="selected" 
            v-if="select" 
            @change="handleChange" 
            v-bind:placeholder=val
        >
            <option value="" disabled >{{val}}</option>
            <option v-for="(option, index) in options" :key="index" :value="option">{{ option }}</option>
        </select>

        <div v-if="radio" class="parameters_Radio">
            <div class="h3 h3_top_0">{{label}}</div>

            <div v-for="(value, key) in radioOptions" :key="key">
                <input type="radio" :id="key" :name="label" :value="key" v-model="selected" @change="handleChange" :checked="key == val" />
                <label :for=option>{{ value }}</label>
            </div>
        </div>

        

        

        <!-- Попап -->
        <div v-if="showPopupKp1" class="popup">
            <div class="popup-content">
                <button @click="closePopupKp1">X</button>
                <img src="../../../public/kp1.jpg" alt="">
            </div>
        </div>

        <div v-if="showPopupKp2" class="popup">
            <div class="popup-content">
                <button @click="closePopupKp2">X</button>
                <img src="../../../public/kp2.jpg" alt="">
            </div>
        </div>
    </div>
</template>
<script>
import { ref, watchEffect, computed } from 'vue'

export default {
    props: {
        labelText: String,
        valueInput: Object
    },
    methods: {
        openPopupKp1() {
            this.showPopupKp1 = true;
        },
        closePopupKp1() {
            this.showPopupKp1 = false;
        },
        openPopupKp2() {
            this.showPopupKp2 = true;
        },
        closePopupKp2() {
            this.showPopupKp2 = false;
        },
        validateInput(label, value) {
            // Добавьте здесь проверки для валидации данных
            // Например, можно проверить наличие значений, тип данных и т.д.
            const regex = /[^.,0-9]/;
            const numericInputs = ["Iкз(3) max", "Iкз(3) min", "Ikz_loading", "ImaxKTP", "IminKTP", "Kp1", "Kp2", "Kp_vvod_cabel", "R1", "Ro", "X1", "Xo", "len_vvod_cabel"];
            if (!numericInputs.includes(label)) {
                console.log(value)
            } else {
                if (regex.test(value)) {
                    console.log("Строка содержит буквы или другие символы, кроме точки и запятой.");
                    alert("Введено не число")
                }
            }
        },
        handleChange() {
            this.$emit('updateProjectParams', this.label, this.selected);
        }
    },
    setup(props) {
        let input = false
        let select = false
        let radio = false
        let options = []
        let selected = ref('')
        let radioOptions = ref({})
        let val = ref(props.valueInput)

        let showPopupKp1 = ref(false)
        let showPopupKp2 = ref(false)

        const tooltips = {
            "Kp1": "Поправочный коэффициент, учитывающий фактическую температуру окружающей среды",
            "Kp2": "Поправочный коэффициент, количество совместно проложенных линий",
        };

        if (props.labelText == 'Категория эл. снаб.') {
            select = true,
                options = ["3"]
            // options = ["3", "1", "2"]
        }
        else if (props.labelText == "Тип заземления") {
            select = true,
                options = ["TN-S", "TN-C-S"]
        }
        else if (props.labelText == "Формат листа") {
            select = true,
                options = ["Формат А3х3 г", "Формат А2х3 г"]
        }
        else if (props.labelText == "Iкз нагрузки") {
            radio = true,
                radioOptions = {
                    "1": "без учета переходных сопротивлений аппаратов и дуги",
                    "2": "с учетом переходных сопротивлений аппаратов и дуги",
                    "3": "с учетом температуры и переходных сопротивлений аппаратов и дуги"
                }
        }
        else {
            input = true
        }

        watchEffect(() => {
            val.value = props.valueInput
        })

        // Вычисляемая подсказка для текущего label
        let tooltip = computed(() => {
            return tooltips[props.labelText] || "";
        });

        return {
            label: props.labelText,
            val,
            input,
            select,
            selected,
            options,
            radio,
            radioOptions,
            tooltip,
            showPopupKp1,
            showPopupKp2,
        }
    }
}
</script>
<style>
.input {
    max-width: 100%;
}

.parameters_Radio {
    padding: 5px 15px 15px 15px;
    border: 1px solid rgb(204, 204, 204);
    border-radius: 20px;
    /* margin: 20px; */
    text-align: left;
}

.h3.h3_top_0 {
    margin-top: 0 !important
}

.popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    /* Полупрозрачный фон */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    /* Чтобы попап был поверх всего */
}

.popup-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
}

.popup-content img {
    max-width: 80%;
    max-height: 80%;
}
.popup-content button{
    top: 20px;
    right: 20px;
    position: absolute;
    font-weight: 800;
    height: 23px;
    width: 23px;
    border-radius: 50%;
    border: 2px solid #004c97;
    cursor: pointer;
    color: #004c97;
    align-items: center;
    justify-content: center;
    display: flex;
}


.kpLink{
    background-color: #004c97;
    color: white;
    width: 20px;
    height: 20px;
    font-size: 15px;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    
}

.kpLink:hover{
    cursor:pointer;
}
</style>